import React from 'react'
import PageBody from '../../components/pagebody/PageBody'
import { Route, Routes, useLocation } from 'react-router-dom'
import { PAYER_SECTION_ROUTES } from './constants'
import AddPayerSuccess from '../components/addpayernew/createone/addpayersuccess/AddPayerSuccess'
import AssignMembers from '../components/addpayernew/assignmembers/AssignMembers'
import BulkUploadSuccess from '../components/addpayernew/bulkupload/bulkuploadsuccess/BulkUploadSuccess'
import PayerList from './payerlist/PayerList'
import EditPayer from '../components/addpayernew/editpayer/EditPayer'
import { componentKey } from './PayerSectionSlice'
import { useSelector } from 'react-redux'
import AddPayer from '../components/addpayernew/AddPayer'
import useGarbageCollector from '../../../libs/garbagecollector/garbageCollectorHooks'

export default function PayersSection() {

    useGarbageCollector(componentKey);
    const location = useLocation();
    const { selectedPayer } = useSelector((state) => state[componentKey]);

    return (
        <PageBody>
            <Routes>
                <Route exact path={"/"} element={<PayerList />} />
                <Route exact path={PAYER_SECTION_ROUTES.ADD} element={<AddPayer />} />

                {/* Edit Payer */}
                <Route exact path={PAYER_SECTION_ROUTES.EDIT} element={<EditPayer payerData={selectedPayer} />} />


                {/* Bulk Upload Success*/}
                <Route exact path={PAYER_SECTION_ROUTES.BULK_PAYER_ADDED} element={<BulkUploadSuccess />} />                
            </Routes>
        </PageBody>
    )
}